module.exports = __webpack_public_path__ + "img/icon-shield.ca2e855a.svg";